import $ from 'jquery';
import toggleVisibility from 'modules/toggle-visibility';
import headerLogout from "./header-logout";
import logout from "modules/logout";
import search from "modules/search";
import revolveMePopup from "modules/revolve-me-popup";
import heartProduct from "modules/heart-product";
import loadFavoriteCount from "./load-favorite-count";
import loadShoppingBagCount from "./load-shopping-bag-count";
import 'modules/page-constrain';
import 'modules/fixed-overlay';
import 'styleguide/modules/slick-carousel';
import zipCodeValidate from 'modules/validate-zip-code';
import { disableBodyScroll } from 'body-scroll-lock';
import Cropper from 'cropperjs';

function fixedOverlay(){
  $('.js-fixed-overlay').fixedOverlay();
}

function categoryNav() {
    var $pageHeaderOverlay = $(".js-page-header-categories-overlay");
    var $pageHeaderTitle = $("#nav-categories");


    $pageHeaderOverlay.on("click", function() {
      $pageHeaderTitle.click();
    });
}

function clickToLogoutFromHeader() {
  headerLogout('#js-header-logout');
}

function toggleRevolveMenu() {
  $('#tr-burger-icon').on('click', function(e) {
    e.preventDefault();
    toggleVisibility('js-top-navigation');
  });
}

function initSearch() {
    $('#tr_top_search_btn, #js-site-search-close').on('click', function(e) {
      e.preventDefault();
      toggleVisibility('js-site-search');
    });
    $(".js-site-search__textbox").removeClass('site-search__textbox--preload');
    search.init();
  // return new Search('#search_term');
}
function loadFavPopups() {
    var $favoritePopupDiv = $("#myFavLimitPopupWrapper");

    if ($favoritePopupDiv.length) {
        $.ajax({
            type: 'GET',
            url: '/content/favorites/fav-max-popup-markup',
            success: function (data) {
                $favoritePopupDiv.empty().append(data);
            },
            failure: function () {
            }
        });
    }
}

function toggleFeaturedShopsMenu() {
    $('#js-featured-menu-button').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        toggleVisibility('featured-shops-list');
    });
}

function validateZipCode(selector){
    return zipCodeValidate(selector);
}

window.initMobileHp = function(){
    window.resetLazyLoad();
    // setupHomeSlideshow();
    toggleFeaturedShopsMenu();
    revolveMePopup();
    $('.js-lazyload-image').lazyLoadImage();
    $('.js-featured-slides').slick({
        arrows: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        accessibility: false,
        touchThreshold: 20,
    });
    $('.js-toggle-display').toggleDisplay();
    $('.js-category-menu').categoryMenu();
}

function initMobileSiteHeader(){
  loadFavoriteCount.then((data) => {
    var favoritesTotal = data.total > 99 ? "99+" : data.total;
    $('#tr_top_heart_mhp_count').empty().append(favoritesTotal);
    $('#tr_top_heart_mhp_count').attr('data-count', data.total);
    if (data.total === 0) {
      $('.fav-count--ab').hide();
    } else {
      $('.fav-count--ab').show();
    }
    var labelText=$('#tr_top_heart_mhp').attr('aria-label');
    if (typeof(labelText) !== 'undefined') {
        $('#tr_top_heart_mhp').attr('aria-label', labelText.replace('{0}', data.total));
    }
  })
  loadShoppingBagCount.then((data) => {
    $('#shopping_bag_count').empty().append(data.itemCount);
    if (data.itemCount === 0) {
      $('.bag-count--ab').hide();
    } else {
      $('.bag-count--ab').show();
    }
    var labelText=$('#tr_top_bag_mhp').attr('aria-label');
    if (typeof(labelText) !== 'undefined') {
        $('#tr_top_bag_mhp').attr('aria-label', labelText.replace('{0}', data.itemCount));
    }
  });
}

const MAX_IMAGE_SEARCH_EDGE = 1024;
const IMAGE_SEARCH_JPEG_QUALITY = 0.8;
const IMAGE_SEARCH_DEFAULT_POLL_TIMEOUT_SECONDS = 20;
const MAX_SEARCH_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024; // 5MB
const MAX_IMAGE_URL_FETCH_BYTES = 10 * 1024 * 1024; // 10MB, to prevent fetching excessively large images from URL
const DEFAULT_IMAGE_SEARCH_FILE_NAME = 'image-search.jpg';
const MAX_ORIGINAL_FILE_NAME_LENGTH = 45;
const MAX_UPLOAD_IMAGE_RETRIES = 2;
const UPLOAD_IMAGE_RETRIES_DELAY_MS = 1000;
const MAX_STATUS_CHECK_RETRIES = 1;
const STATUS_CHECK_RETRY_DELAY_MS = 500;
let isImageSearchRunning = false;
let isImagePreparing = false;
let cropImageObjectUrl = null;

const ImageSearchErrorCode = Object.freeze({
    UNKNOWN: 100,

    // validation
    INVALID_IMAGE: 101,
    INVALID_IMAGE_DIMENSION: 102,
    IMAGE_TOO_LARGE: 103,

    // processing
    IMAGE_READ_FAILED: 104,
    IMAGE_ENCODE_FAILED: 105,
    CANVAS_NOT_SUPPORTED: 106,

    // upload
    UPLOAD_FAILED: 201,
    MISSING_EVENT_ID: 202,

    // polling
    STATUS_CHECK_FAILED: 301,
    INVALID_JSON_RESPONSE: 302,
    INVALID_RETRY_VALUE: 303,
    INVALID_RETRY_NON_POSITIVE: 304,
    TIMEOUT: 305,

    // url
    INVALID_URL: 401,
    URL_FETCH_FAILED: 402,
    URL_NOT_IMAGE: 403
});

class ImageSearchError extends Error {
    constructor(code, message, details) {
        super(message || `Image search failed, error=${code}`);
        this.code = code;
        this.details = details;
        this.name = 'ImageSearchError';
    }
}

function getImageSearchErrorMessage(err) {
    const code = err && err.code ? err.code : ImageSearchErrorCode.UNKNOWN;
    return `Image search failed, error=${code}`;
}

function showImageSearchError(message, details) {
    let finalMessage = message || `Image search failed, error=${ImageSearchErrorCode.UNKNOWN}`;

    if (details) {
        finalMessage += `\nDetails: ${details}`;
    }

    alert(finalMessage);
}

// sleep during image search polling interval
function imageSearchSleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

// Decode a File/Blob into something canvas.drawImage() can use.
// Prefer createImageBitmap for performance; fall back to <img> for compatibility.
async function loadImageBitmapOrFallback(sourceFileOrBlob) {
    if (window.createImageBitmap) {
        try {
            return await createImageBitmap(sourceFileOrBlob);
        } catch (err) {
            throw new ImageSearchError(
                ImageSearchErrorCode.IMAGE_READ_FAILED,
                null,
                'createImageBitmap failed'
            );
        }
    }
    const objectUrl = URL.createObjectURL(sourceFileOrBlob);
    return new Promise(function (resolve, reject) {
        const image = new Image();

        function cleanup() {
            image.onload = null;
            image.onerror = null;
            URL.revokeObjectURL(objectUrl);
        }

        image.onload = function () {
            cleanup();
            resolve(image);
        };

        image.onerror = function () {
            cleanup();
            reject(new ImageSearchError(
                ImageSearchErrorCode.IMAGE_READ_FAILED,
                null,
                'image load failed'
            ));
        };

        image.src = objectUrl;
    });
}

/*
 * Preprocess image before upload:
 * - resize the longest edge to <= 1024px
 * - preserve aspect ratio
 * - re-encode as JPEG quality 0.8
 * - strip EXIF metadata by redrawing via canvas
 * - reject if processed file is still > 5MB
 */
async function prepareImageForUpload(sourceFileOrBlob, onErrorMessage) {
    function showMessage(msg) {
        if (typeof onErrorMessage === 'function') {
            onErrorMessage(msg);
        } else {
            console.log(msg);
        }
    }

    if (!sourceFileOrBlob || !sourceFileOrBlob.type || !sourceFileOrBlob.type.startsWith('image/')) {
        showMessage('Please choose a valid image.');
        return null;
    }

    let img = null;

    try {
        img = await loadImageBitmapOrFallback(sourceFileOrBlob);

        let width = img.width;
        let height = img.height;

        if (!width || !height) {
            showMessage('Invalid image dimensions.');
            return null;
        }

        const longestEdge = Math.max(width, height);

        if (longestEdge > MAX_IMAGE_SEARCH_EDGE) {
            const scale = MAX_IMAGE_SEARCH_EDGE / longestEdge;
            width = Math.max(1, Math.round(width * scale));
            height = Math.max(1, Math.round(height * scale));
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            showMessage('Browser does not support image processing.');
            return null;
        }

        try {
            ctx.drawImage(img, 0, 0, width, height);
        } catch (err) {
            showMessage(`Image search failed, error=${ImageSearchErrorCode.IMAGE_READ_FAILED}`);
            return null;
        }

        let jpegBlob;
        try {
            jpegBlob = await new Promise(function (resolve, reject) {
                try {
                    canvas.toBlob(function (blob) {
                        if (!blob) {
                            reject(new ImageSearchError(
                                ImageSearchErrorCode.IMAGE_ENCODE_FAILED,
                                null,
                                'canvas.toBlob returned null'
                            ));
                            return;
                        }
                        resolve(blob);
                    }, 'image/jpeg', IMAGE_SEARCH_JPEG_QUALITY);
                } catch (err) {
                    reject(new ImageSearchError(
                        ImageSearchErrorCode.IMAGE_ENCODE_FAILED,
                        null,
                        'canvas.toBlob threw exception'
                    ));
                }
            });
        } catch (err) {
            showMessage(err && err.message
                ? err.message
                : `Image search failed, error=${ImageSearchErrorCode.IMAGE_ENCODE_FAILED}`);
            return null;
        }
        
        if (jpegBlob.size > MAX_SEARCH_IMAGE_UPLOAD_BYTES) {
            showMessage('Image is still larger than 5MB after processing. Please choose a smaller image.');
            return null;
        }

        return jpegBlob;
    } catch (err) {
        showMessage(err && err.message
            ? err.message
            : `Image search failed, error=${ImageSearchErrorCode.IMAGE_READ_FAILED}`);
        return null;
    } finally {
        if (img && typeof img.close === 'function') {
            try {
                img.close();
            } catch (e) {
                // no-op
            }
        }
    }
}

async function setupImageForCropping(jpegBlob, onErrorMessage) {
    if (!jpegBlob) {
        return false;
    }

    function showMessage(msg) {
        if (typeof onErrorMessage === 'function') {
            onErrorMessage(msg);
        } else {
            console.log(msg);
        }
    }

    try {
        const cropLoadingImg = $('#crop-loading-img')[0];
        const cropImg = $('#js-visual-search-image')[0];

        if (!cropImg) {
            showMessage('Image processing failed. Please try another image.');
            return false;
        }

        // Clean up previous crop image URL before creating a new one.
        if (cropImageObjectUrl) {
            URL.revokeObjectURL(cropImageObjectUrl);
            cropImageObjectUrl = null;
        }

        cropImageObjectUrl = URL.createObjectURL(jpegBlob);

        function loadImage(img, url) {
            return new Promise((resolve, reject) => {
                img.onload = function () {
                    img.onload = null;
                    img.onerror = null;
                    resolve();
                };

                img.onerror = function () {
                    img.onload = null;
                    img.onerror = null;
                    reject(new ImageSearchError(
                        ImageSearchErrorCode.IMAGE_READ_FAILED,
                        null,
                        'crop image load failed'
                    ));
                };

                img.src = url;
            });
        }

        await Promise.all([
            cropLoadingImg ? loadImage(cropLoadingImg, cropImageObjectUrl) : Promise.resolve(),
            cropImg ? loadImage(cropImg, cropImageObjectUrl) : Promise.resolve()
        ]);

        return true;
    } catch (err) {
        showMessage('Image processing failed. Please try another image.');
        return false;
    }
}

function buildImageSearchFormData(file, originalFileName) {
    const formData = new FormData();
    formData.append('image', file, file.name || DEFAULT_IMAGE_SEARCH_FILE_NAME);

    if (originalFileName) {
        formData.append('originalFileName', originalFileName);
    }

    return formData;
}

async function uploadPreparedImage(file, originalFileName) {
    for (let attempt = 0; attempt <= MAX_UPLOAD_IMAGE_RETRIES; attempt++) {
        let response;
        try {
            response = await fetch('/content/image-search/upload', {
                method: 'POST',
                body: buildImageSearchFormData(file, originalFileName)
            });
        } catch (err) {
            if (attempt < MAX_UPLOAD_IMAGE_RETRIES) {
                await imageSearchSleep(UPLOAD_IMAGE_RETRIES_DELAY_MS * (attempt + 1));
                continue;
            }
            throw new ImageSearchError(
                ImageSearchErrorCode.UPLOAD_FAILED,
                null,
                `fetch failed after ${MAX_UPLOAD_IMAGE_RETRIES + 1} attempts, name=${err && err.name}, message=${err && err.message}, online=${navigator.onLine}`
            );
        }

        if (!response.ok) {
            throw new ImageSearchError(
                ImageSearchErrorCode.UPLOAD_FAILED,
                null,
                `status=${response.status}`
            );
        }

        try {
            return await response.json();
        } catch (err) {
            throw new ImageSearchError(
                ImageSearchErrorCode.INVALID_JSON_RESPONSE,
                null,
                'Invalid JSON in upload response'
            );
        }
    }
}

// Poll backend for image search status.
// Backend may either:
// 1) keep returning retryAfterSeconds, or
// 2) return a redirectUrl when search results are ready.
async function checkImageSearchStatus(eventId) {
    for (let attempt = 0; attempt <= MAX_STATUS_CHECK_RETRIES; attempt++) {
        let res;
        try {
            res = await fetch('/content/image-search/check-status?eventId='
                + encodeURIComponent(eventId), {
                cache: 'no-store'
            });
        } catch (err) {
            if (attempt < MAX_STATUS_CHECK_RETRIES) {
                await imageSearchSleep(STATUS_CHECK_RETRY_DELAY_MS);
                continue;
            }
            throw new ImageSearchError(
                ImageSearchErrorCode.STATUS_CHECK_FAILED,
                null,
                `fetch failed after ${MAX_STATUS_CHECK_RETRIES + 1} attempts, name=${err && err.name}, message=${err && err.message}, online=${navigator.onLine}`
            );
        }

        if (!res.ok) {
            throw new ImageSearchError(
                ImageSearchErrorCode.STATUS_CHECK_FAILED,
                null,
                `status=${res.status}`
            );
        }

        try {
            return await res.json();
        } catch (e) {
            throw new ImageSearchError(
                ImageSearchErrorCode.INVALID_JSON_RESPONSE,
                null,
                'Invalid JSON in check-status response'
            );
        }
    }
}

function normalizeRetryAfterSeconds(value) {
    const normalized = typeof value === 'string' ? Number($.trim(value)) : value;

    if (typeof normalized !== 'number' || isNaN(normalized)) {
        throw new ImageSearchError(
            ImageSearchErrorCode.INVALID_RETRY_VALUE,
            null,
            `waitSeconds=${value}`
        );
    }

    if (normalized <= 0) {
        throw new ImageSearchError(
            ImageSearchErrorCode.INVALID_RETRY_NON_POSITIVE,
            null,
            `waitSeconds=${value}`
        );
    }

    return normalized;
}

// Keep polling until backend returns redirectUrl, an error occurs, or timeout is reached.
async function pollImageSearchResult(uploadResponse) {
    const eventId = uploadResponse && uploadResponse.eventId;
    const timeoutSeconds = uploadResponse && uploadResponse.timeout;
    let retryAfterSeconds = uploadResponse && uploadResponse.retryAfterSeconds;

    if (!eventId) {
        throw new ImageSearchError(
            ImageSearchErrorCode.MISSING_EVENT_ID,
            null,
            'No event id in polling image.'
        );
    }

    const effectiveTimeout = typeof timeoutSeconds === 'number' && timeoutSeconds > 0
        ? timeoutSeconds
        : IMAGE_SEARCH_DEFAULT_POLL_TIMEOUT_SECONDS;
    const deadline = Date.now() + (effectiveTimeout * 1000);

    while (true) {
        if (Date.now() > deadline) {
            return {
                timedOut: true
            };
        }

        const waitSeconds = retryAfterSeconds == null
            ? 3
            : normalizeRetryAfterSeconds(retryAfterSeconds);
        const remainingMs = deadline - Date.now();
        if (remainingMs <= 0) {
            return {
                timedOut: true
            };
        }
        await imageSearchSleep(Math.min(waitSeconds * 1000, remainingMs));

        const checkResponse = await checkImageSearchStatus(eventId);

        if (checkResponse && checkResponse.redirectUrl) {
            return checkResponse;
        }

        if (checkResponse && checkResponse.errorMessage) {
            throw new ImageSearchError(
                ImageSearchErrorCode.STATUS_CHECK_FAILED,
                null,
                `backendError=${checkResponse.errorMessage}`
            );
        }

        retryAfterSeconds = checkResponse && checkResponse.retryAfterSeconds != null
            ? checkResponse.retryAfterSeconds
            : waitSeconds;
    }
}

// Shared entry point after image has already been preprocessed.
// Upload -> show loading modal -> poll until redirect or timeout.
async function startImageSearch(processedFile, onError, originalFileName) {
    if (isImageSearchRunning) {
        return;
    }

    isImageSearchRunning = true;
    
    let previewUrl = null;

    try {
        const uploadResponse = await uploadPreparedImage(processedFile, originalFileName);
        if (!uploadResponse || !uploadResponse.eventId) {
            const errorDetails = !uploadResponse ? 'no uploadResponse' : 'no event id';
            onError(`Image search failed, error=${ImageSearchErrorCode.UPLOAD_FAILED}`, errorDetails);
            return;
        }

        previewUrl = setLoadingModalImage(processedFile);
        $.modal.close();
        openImageSearchLoadingModal();

        const finalResponse = await pollImageSearchResult(uploadResponse);

        if (finalResponse && finalResponse.redirectUrl) {
            clearLoadingModalImage(previewUrl);
            window.location.href = finalResponse.redirectUrl;
            return;
        }

        $.modal.close();
        clearLoadingModalImage(previewUrl);

        if (finalResponse && finalResponse.timedOut) {
            onError(`Image search failed, error=${ImageSearchErrorCode.TIMEOUT}`);
            return;
        }

        onError(`Image search failed, error=${ImageSearchErrorCode.UNKNOWN}`);
    } catch (err) {
        $.modal.close();
        clearLoadingModalImage(previewUrl);

        console.error('Image search failed:', err);
        onError(
            getImageSearchErrorMessage(err),
            err && err.details
        );
    } finally {
        isImageSearchRunning = false;
    }
}

// Show the processed image in loading modal before polling starts.
function setLoadingModalImage(file) {
    const $img = $('#loading-modal-image');
    if (!$img.length || !file) {
        return null;
    }
    // This is not internet URL, but setup img blob URL in browser internal memory
    const previewUrl = URL.createObjectURL(file);
    $img.attr('src', previewUrl);
    return previewUrl;
}

function clearLoadingModalImage(previewUrl) {
    if (previewUrl) {
        try {
            URL.revokeObjectURL(previewUrl);
        } catch (e) {
            // no-op
        }
    }

    const $img = $('#loading-modal-image');
    if ($img.length) {
        $img.attr('src', '');
    }
}

function openImageSearchLoadingModal() {
    $.modal({
        open: 'image-search-loading-modal',
        type: 'full',
        triggerOpen: true,
        closeButton: false,
        addModifierClass: 'ab553__processing-modal',
        onClose() {
            $('.form-search-overlay').show();
            const $searchResults = $('.site-search__results');
            if ($searchResults.length) {
                disableBodyScroll($searchResults[0]);
            }
            window.scrollTo(0, 0);
        },
        onComplete() {
            const $status = $('.ab553__processing-status');
            setTimeout(function () {
                $status.text('searching...');
            }, 2000);
        }
    });
}

function imageSearchEngagementTracking(isUrlFetch, error) {
    if (typeof isUrlFetch !== 'boolean') {
        console.warn('imageSearchEngagementTracking: isUrlFetch must be a boolean');
        return;
    }

    const trackingData = {
        url: window.location.href,
        isUrlFetch: isUrlFetch,
        ...(error && { error: error instanceof Error ? error.message : `${error}` })
    };

    $.ajax({
        type: 'GET',
        url: '/content/image-search/engagement-tracking',
        data: trackingData,
        timeout: 5000,
        error(jqXHR, textStatus, errorThrown) {
            console.warn('imageSearchEngagementTracking: request failed', { textStatus, errorThrown });
        }
    });
}

function extractFileNameFromUrl(url) {
    try {
        const pathname = new URL(url).pathname;
        let name = pathname.split('/').pop();
        name = name.split('?')[0].split('#')[0];
        name = decodeURIComponent(name);
        if (!name || name.trim() === '') {
            return DEFAULT_IMAGE_SEARCH_FILE_NAME;
        }
        return name;
    } catch {
        return DEFAULT_IMAGE_SEARCH_FILE_NAME;
    }
}

function sanitizeOriginalFileName(name) {
    if (typeof name !== 'string' || !name.trim()) {
        return DEFAULT_IMAGE_SEARCH_FILE_NAME;
    }

    name = name.trim().replace(/[\r\n\t]/g, ' ');

    if (!name) {
        return DEFAULT_IMAGE_SEARCH_FILE_NAME;
    }

    if (name.length <= MAX_ORIGINAL_FILE_NAME_LENGTH) {
        return name;
    }

    const dotIndex = name.lastIndexOf('.');
    const hasExt = dotIndex > 0 && dotIndex < name.length - 1;
    const ext = hasExt ? name.substring(dotIndex) : '';

    const allowedNameLength = MAX_ORIGINAL_FILE_NAME_LENGTH - ext.length;

    if (allowedNameLength <= 0) {
        return name.substring(0, MAX_ORIGINAL_FILE_NAME_LENGTH);
    }

    return name.substring(0, allowedNameLength) + ext;
}

$(document).ready(function() {
  clickToLogoutFromHeader();
  initSearch();
  initMobileSiteHeader();
  toggleRevolveMenu();
  //toggleDisplay();
  categoryNav();
  fixedOverlay();
  loadFavPopups();
  window.headerLogOut = logout;

  if($('#tryonlpProducts').length) {
      heartProduct('#tryonlpProducts', '.fav-item');
  }

  // clearSearchCookiesFromHeader();
  // initMobileMenu();
  window.validateZipCode = validateZipCode;
  window.submitHeart = function(paramtype, paramvalue, action, psize, sectionUrl){
      //this method is used by /r/dialog/ShoppingBagLimit.jsp
      heartProduct.submitHeart(paramtype, paramvalue, action, psize, sectionUrl, function () {
          var favBtnOnPDP = $('.js-fav-button');
          if(favBtnOnPDP.length > 0 && !favBtnOnPDP.hasClass('favorite-button--active')){
              favBtnOnPDP.addClass('favorite-button--active');
          }

          if(window.rcProps && typeof window.rcProps.ReCAPTCHARestore =='function'){
              window.rcProps.ReCAPTCHARestore();
              window.rcProps.ReCAPTCHARestore = "";
          }
          if($('#move-to-fav-notification-modal').length > 0){
              $.ajax({
                  type: 'GET',
                  url: '/content/favorites/moveToFav',
                  success: function (data) {
                      $('body').append(data);
                      $.modal({triggerOpen:true, open: "move-to-fav-notification-modal"});
                  },
                  failure: function () {
                  }
              });

          }else{
              $.modal.close();
          }
      });
  };
    $(".js-close-banner").click(function () {
        $.post("/r/ajax/SetRevolveSessionParam.jsp", $.param({
            "key": "rglobalbannerdismiss",
            "value": "disableglobalbanner"
        }), function () {});
    });
    $('#iphoneRestrictionsAnchor').click(function(e) {
        e.preventDefault();
        $.modal({
            url: "/content/favorites/mobile/appRestrictionPopup",
            type: "toast",
            triggerOpen: true,
            returnFocus: "#iphoneRestrictionsAnchor"
        });
    });
    
    // AB553 Mock Content Start

    if ($('.ab553').length) {
        function disableCroppedSubmitButton($button) {
            $button.addClass('disabled')
                .css('pointer-events', 'none')
                .attr('aria-disabled', 'true');
        }

        function enableCroppedSubmitButton($button) {
            $button.removeClass('disabled')
                .css('pointer-events', 'initial')
                .attr('aria-disabled', 'false');
        }
        
        window.addEventListener('pagehide', function () {
            // Handle iOS/Safari bfcache (e.g. back swipe).
            // When the page is restored from bfcache, previous modal/cropper state may persist.
            // Clean up before page is cached to avoid stale UI/state issues.
            // This is registered once at the top level to avoid duplicate listeners.
            $.modal.close();
            if (window.VisualSearchCropper) {
                window.VisualSearchCropper.destroy();
            }
        });
        // AB553 New Mock Content Start
        // Keep cropper state private and avoid leaking variables globally.
        (function () {
            let cropper = null;

            function initVisualSearchCropper(imageEl) {
                if (!imageEl) return;

                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }
                
                window.VisualSearchCropper._currentBlob = null;

                cropper = new Cropper(imageEl, {
                    center: false,
                    dashed: false,
                    guides: false,
                    responsive: true,
                    rotatable: false,
                    scalable: false,
                    viewMode: 1,
                    zoomable: false,
                    zoomOnWheel: false,

                    ready() {
                        const $loader = $('#crop-module-loading-modal .ab553__is-processing');
                        const $cropImage = $('#crop-module-loading-modal .crop-image');
                        const $cropSubmit = $('#js-visual-search-crop-submit');

                        $loader.addClass('u-hide');
                        $cropImage.css({ position: 'initial', opacity: 'initial' });
                        enableCroppedSubmitButton($cropSubmit);

                        getCroppedBlob()
                            .then(function (blob) {
                                window.VisualSearchCropper._currentBlob = blob;
                            })
                            .catch(function (err) {
                                console.error('Failed to get cropped image:', err);
                            });
                    },

                    cropmove(e) {
                        const action = e.detail && e.detail.action;
                        const cropperEl = cropper && cropper.cropper;
                        if (!cropperEl) {
                            return;
                        }

                        if (action === 'ne') {
                            const point = cropperEl.querySelector('.cropper-point.point-ne');
                            if (point) {
                                point.classList.add('is-engaged');
                            }
                        } else if (action === 'sw') {
                            const point = cropperEl.querySelector('.cropper-point.point-sw');
                            if (point) {
                                point.classList.add('is-engaged');
                            }
                        }
                    },

                    cropend() {
                        const cropperEl = cropper && cropper.cropper;
                        if (cropperEl) {
                            const nePoint = cropperEl.querySelector('.cropper-point.point-ne');
                            const swPoint = cropperEl.querySelector('.cropper-point.point-sw');

                            if (nePoint) {
                                nePoint.classList.remove('is-engaged');
                            }
                            if (swPoint) {
                                swPoint.classList.remove('is-engaged');
                            }
                        }

                        getCroppedBlob()
                            .then(function (blob) {
                                if (blob) {
                                    window.VisualSearchCropper._currentBlob = blob;
                                }
                            })
                            .catch(function (err) {
                                console.error('Failed to get cropped image:', err);
                            });
                    }
                });

                return cropper;
            }

            function getCroppedBlob() {
                if (!cropper) {
                    return Promise.resolve(null);
                }

                const canvas = cropper.getCroppedCanvas({
                    maxWidth: MAX_IMAGE_SEARCH_EDGE,
                    maxHeight: MAX_IMAGE_SEARCH_EDGE,
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: 'high'
                });

                if (!canvas) {
                    return Promise.resolve(null);
                }

                return new Promise((resolve, reject) => {
                    canvas.toBlob(function (blob) {
                        if (!blob) {
                            reject(new ImageSearchError(
                                ImageSearchErrorCode.IMAGE_ENCODE_FAILED,
                                null,
                                'crop canvas.toBlob returned null'
                            ));
                            return;
                        }
                        resolve(blob);
                    }, 'image/jpeg', IMAGE_SEARCH_JPEG_QUALITY);
                });
            }

            function destroyCropper() {
                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }

                if (cropImageObjectUrl) {
                    URL.revokeObjectURL(cropImageObjectUrl);
                    cropImageObjectUrl = null;
                }
                
                window.VisualSearchCropper._currentBlob = null;
            }

            window.VisualSearchCropper = {
                init: initVisualSearchCropper,
                getBlob: getCroppedBlob,
                destroy: destroyCropper,
            };
        })();
        
        function startCropImage(originalFileName) {
            $.modal({
                open: 'crop-module-loading-modal',
                type: 'full',
                triggerOpen: true,
                closeButton: false,
                addModifierClass: 'ab553__processing-modal',
                onClose() {
                    window.VisualSearchCropper.destroy();
                    $('.form-search-overlay').show();
                    const $searchResults = $('.site-search__results');
                    if ($searchResults.length) {
                        disableBodyScroll($searchResults[0]);
                    }
                    window.scrollTo(0, 0);
                },
                onComplete() {
                    const image = document.getElementById('js-visual-search-image');
                    const $status = $('#image-search-crop-processing-status');
                    const $cropSubmit = $('#js-visual-search-crop-submit');
                    const $cropError = $('#crop-img-error');
                    const $cropImage = $('#crop-module-loading-modal .crop-image');

                    $cropError.text('').hide();

                    // Reset previous crop image size. The modal DOM is reused after cancel.
                    $cropImage
                        .removeClass('crop-image--tall')
                        .css({
                            width: '',
                            height: '',
                            position: '',
                            opacity: ''
                        });

                    disableCroppedSubmitButton($cropSubmit);
                    $status.text('loading...');

                    if (!image) return;

                    function setDynamicCropHeight(imageEl) {
                        const $cropImage = $('#crop-module-loading-modal .crop-image');
                        if (!$cropImage.length || !imageEl.naturalWidth || !imageEl.naturalHeight) {
                            return;
                        }

                        const maxWidth = Math.min(window.innerWidth * 0.82, 700);
                        const maxHeight = window.innerHeight * 0.65;

                        const scale = Math.min(
                            maxWidth / imageEl.naturalWidth,
                            maxHeight / imageEl.naturalHeight
                        );

                        $cropImage
                            .width(Math.round(imageEl.naturalWidth * scale))
                            .height(Math.round(imageEl.naturalHeight * scale))
                            .toggleClass('crop-image--tall', (maxHeight / imageEl.naturalHeight) < (maxWidth / imageEl.naturalWidth));
                    }

                    if (image.complete && image.naturalHeight !== 0) {
                        setDynamicCropHeight(image);
                        window.VisualSearchCropper.init(image);
                    } else {
                        image.onload = function() {
                            setDynamicCropHeight(image);
                            window.VisualSearchCropper.init(image);
                        };
                    }

                    $cropSubmit.off('click').on('click', async function () {
                        disableCroppedSubmitButton($cropSubmit);
                        let blob = null;
                        try {
                            blob = await window.VisualSearchCropper.getBlob();
                        } catch (err) {
                            console.error('Failed to get cropped image:', err);
                        }
                        if (!blob) {
                            $cropError.text('Failed to get cropped image. Please try again.').show();
                            // allow retry if crop failed
                            enableCroppedSubmitButton($cropSubmit);
                            return;
                        }
                        
                        try {
                            await startImageSearch(blob, showImageSearchError, originalFileName);
                        } catch (err) {
                            console.error('Image upload failed:', err);
                            showImageSearchError(
                                getImageSearchErrorMessage(err),
                                err && err.details
                            )
                            enableCroppedSubmitButton($cropSubmit);
                        }
                    });
                }
            });
        }
        // AB553 New Mock Content End

      const $visualSearchButton = $('.js-image-search-btn');

      $visualSearchButton.on('click', () => {
        $.modal({
          open: 'image-search-modal',
          type: 'toast',
          closeButton: true,
          triggerOpen: true,
          triggerElement: $visualSearchButton,
          addModifierClass: 'ab553__visual-modal',
          onClose() {
            const $formSearchOverlay = $('.form-search-overlay');
            const $searchResults = $('.site-search__results');

            $formSearchOverlay.show();
            if ($searchResults.length) {
              disableBodyScroll($searchResults[0]);
            }
            window.scrollTo(0, 0);
          },
          onComplete() {
            const $fileInputUpload = $('#visual-search-photo-upload');
            const $uploadButton = $('#visual-search-upload-button');
            const $pastePhotoButton = $('#visual-search-paste-photo-button');
            const $photoURLCancelButton = $('#visual-search-photo-url-cancel-button');
            const $buttonGroup = $('.ab553__visual-modal-buttongroup');
            const $pastePhotoForm = $('.ab553__visual-modal-url-form');
            const $formSearchOverlay = $('.form-search-overlay');
            const $imageUrlFeedback = $('#image-url-feedback');
            const $selectImageFeedback = $('#select-image-feedback');
            const $imageUrlInput = $('#visual-search-photo-url-input');

            // Reset UI state
            $pastePhotoForm.hide();
            $buttonGroup.show();
            $imageUrlInput.val('');
            $imageUrlInput.closest('.field').removeClass('is-error');
            $imageUrlFeedback.text('').hide();
            $selectImageFeedback.text('').hide();

            $formSearchOverlay.hide();

            $uploadButton.off('click').on('click', () => {
              $fileInputUpload.click();
            });

            $pastePhotoButton.off('click').on('click', () => {
              $buttonGroup.hide();
              $pastePhotoForm.show();
            });

            $photoURLCancelButton.off('click').on('click', () => {
              $pastePhotoForm.hide();
              $buttonGroup.show();
              $imageUrlInput.val('');
            });
          }
        });
      });
      
      // local image file upload
      $('#visual-search-photo-upload').on('change', async function () {
        const $feedback = $('#select-image-feedback');
        const input = this;
        const file = input.files && input.files[0];
        try {
          if (!file) {
            $feedback.text('Please select a valid image').show();
            return;
          }

          if (isImagePreparing || isImageSearchRunning) {
            $feedback.text('Image search is already in progress.').show();
            return;
          }
          isImagePreparing = true;
          
          $feedback.hide();
          const processedFile = await prepareImageForUpload(file, function (msg) {
            $feedback.text(msg).show();
          });
          
          if (!processedFile) {
              return;
          }

          const cropImageReady = await setupImageForCropping(processedFile, function (msg) {
              $feedback.text(msg).show();
          });
          if (cropImageReady) {
            imageSearchEngagementTracking(false);
            const originalFileName = sanitizeOriginalFileName(file.name);
            startCropImage(originalFileName);
          }
          
        } catch (err) {
          console.error('Image upload failed:', err);
          $feedback.text('Image upload failed.').show();
          showImageSearchError(
              getImageSearchErrorMessage(err),
              err && err.details
          );
          imageSearchEngagementTracking(false, err);
        } finally {
            $(input).val('');
            isImagePreparing = false;
        }
      });

      function isValidUrl(str) {
        try {
          const url = new URL(str);
          return ['http:', 'https:'].includes(url.protocol) && url.hostname;
        } catch (e) {
          return false;
        }
      }

      // image url upload
      $('.ab553__visual-modal-url-form').on('submit', async function (e) {
        e.preventDefault();
        const $input = $('#visual-search-photo-url-input');
        const $field = $input.closest('.field');
        const $feedback = $('#image-url-feedback');
        const imageUrl = $.trim($input.val());

        $field.removeClass('is-error');
        $feedback.hide();
        
        if (!imageUrl || !isValidUrl(imageUrl)) {
            $input.closest('.field').addClass('is-error');
            $feedback.text('Please enter a valid public URL').show();
            return;
        }

        if (isImagePreparing || isImageSearchRunning) {
          $feedback.text('Image search is already in progress.').show();
          return;
        }
        isImagePreparing = true;

        const unsupportedUrlMessage = "This image URL is not supported. Please download it first and upload it using the 'Upload From Device' option instead.";
        try {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 10000);

          let imageResponse;
          try {
            imageResponse = await fetch(imageUrl, { signal: controller.signal });
          } finally {
            clearTimeout(timer);
          }
          if (!imageResponse.ok) {
            $field.addClass('is-error');
            $feedback.text(unsupportedUrlMessage).show();
            return;
          }

          const contentType = imageResponse.headers.get('content-type') || '';
          if (!contentType.startsWith('image/')) {
            $field.addClass('is-error');
            $feedback.text('The provided URL does not point to a valid image.').show();
            return;
          }

          const contentLength = imageResponse.headers.get('content-length');
          if (contentLength && parseInt(contentLength, 10) > MAX_IMAGE_URL_FETCH_BYTES) {
            $field.addClass('is-error');
            $feedback.text('Image is too large. Please choose a smaller image.').show();
            return;
          }
          
          const blob = await imageResponse.blob();
          if (blob.size > MAX_IMAGE_URL_FETCH_BYTES) {
            $field.addClass('is-error');
            $feedback.text('Image is too large. Please choose a smaller image.').show();
            return;
          }
          
          const processedFile = await prepareImageForUpload(blob, function (msg) {
            $feedback.text(msg).show();
          });

          if (!processedFile) {
            return;
          }
          
          const cropImageReady = await setupImageForCropping(processedFile, function (msg) {
            $feedback.text(msg).show();
          });
          if (cropImageReady) {
            imageSearchEngagementTracking(true);
            const extractedFileNameFromUrl = extractFileNameFromUrl(imageUrl);
            const originalFileName = sanitizeOriginalFileName(extractedFileNameFromUrl);
            startCropImage(originalFileName);
          }
        } catch (err) {
          console.error('Image URL upload failed:', err);
          $field.addClass('is-error');
          if (err && err.name === 'AbortError') {
            $feedback.text('Request timed out. Please try again.').show();
          } else {
            $feedback.text(unsupportedUrlMessage).show();
          }
          imageSearchEngagementTracking(true, err);
        } finally {
          isImagePreparing = false;
        }
      });
    }
    // AB553 Mock Content End
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js